import React from 'react';
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../../../components/Box';
import { Button } from '../../../../../components/Buttons';
import { Loader } from '../../../../../components/Loader';
import {selectConfig, selectWorks} from '../../../../Api/selectors';
import { createVehicleWithProps } from '../../../actions';
import {
  REQUEST_VEHICLE,
  VEHICLE_FINANCIAL_PURCHASE_PRICE_TYPES_BTW,
  VEHICLE_FINANCIAL_PURCHASE_PRICE_TYPES_MARGE,
  CALCULATE_PURCHASE_PRICES_BTW,
  CALCULATE_PURCHASE_PRICES_MARGE,
  WIENTJES_VEHICLE_FINANCIAL_PURCHASE_PRICE_TYPES_BTW, VEHICLE_PURPOSE, VEHICLE_TAX_TYPE,
} from '../../../constants';
import { VehicleCreateField } from './Fields';
import { selectNewVehicle } from '../../../selectors';
import _ from 'lodash';
import {
  PURCHASING_DATA_CRUD,
  PURCHASING_PRICES_CRUD,
  SALES_DATA_CRUD,
  SALES_PRICES_CRUD,
} from '../../../../../components/Permission/constants';
import { Permission } from '../../../../../components/Permission';
import env from '../../../../../env';
import { AppClientId } from '../../../../Shared/constants';
import cn from 'classnames';
import styles from './SecondStep.module.css';
import ButtonComponent from '../../../../../containers/App/Components/Button/Button';

const Container = styled.div`
  width: 100%;
  .cols {
  }
  .col {
    min-width: 400px;
    padding-right: 48px;
  }

  .info-card {
    padding: 24px;
    width: auto;
    h2 {
      margin-bottom: 24px;
    }
    .btn {
      margin: 6px;
    }
  }
`;

const STATE = {
  disableSave: false,
};

class VehicleCreateStep2Comp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  save() {
    this.props.onSave();
  }

  prevStep() {
    this.props.getPrevStep();
  }

  get isInstallation() {
    return (
      env.clientId === AppClientId.AUTOWIENTJES ||
      env.clientId === AppClientId.HARRY_NIJBOER ||
      env.clientId === AppClientId.HOOIKAMMER ||
      env.clientId === AppClientId.INDEWAL ||
      env.clientId === AppClientId.IDWLEASE ||
      env.clientId === AppClientId.AUTOHUISSALLAND
    );
  }

  getPurchaseColumnsArr() {
    let columns = this.isInstallation ? [] : ['vehicle_purpose', 'tax_type'];

    if (!this.props.values?.vehicle_purpose) {
      return columns;
    }

    if (this.props.values?.tax_type === 'BTW') {
      columns = columns.concat(...this.withInstallationProps());
      if (env.clientId === AppClientId.INDEWAL || env.clientId === AppClientId.HARRY_NIJBOER || env.clientId === AppClientId.IDWLEASE) {
        columns.push('financial_bpm_gross');
      }
      if (!this.props.serverConfig.disableBPM) {
        const isCommercial = this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Commercial;
        const dateFirstAllowance = this.props.values?.date_first_allowance;
        const is2025OrLater = dateFirstAllowance ? new Date(dateFirstAllowance).getFullYear() >= 2025 : true;

        if (isCommercial && is2025OrLater) columns.push('financial_purchase_price_incl_bpm_excl_btw');
      }
    }

    if (this.props.values.tax_type === 'marge') {
      columns = columns.concat(...VEHICLE_FINANCIAL_PURCHASE_PRICE_TYPES_MARGE);
      if (this.isInstallation) {
        columns = columns.filter(prop => prop != 'financial_bpm_gross');
      }
      if (env.clientId === AppClientId.INDEWAL || env.clientId === AppClientId.HARRY_NIJBOER || env.clientId === AppClientId.IDWLEASE) {
        columns.push('financial_bpm_gross');
      }
    }

    return columns;
  }

  toggleDisableSave = value => {
    this.setState({ disableSave: value });
  };

  get purchasingDataProps() {
    return ['buying_company', 'buying_contact'];
  }

  withInstallationProps() {
    let purchaseFields = this.isInstallation
      ? WIENTJES_VEHICLE_FINANCIAL_PURCHASE_PRICE_TYPES_BTW
      : VEHICLE_FINANCIAL_PURCHASE_PRICE_TYPES_BTW;

    return purchaseFields;
  }

  get purchasingPricesProps() {
    return ['vehicle_purpose', 'tax_type', ...this.withInstallationProps(), ...VEHICLE_FINANCIAL_PURCHASE_PRICE_TYPES_MARGE];
  }

  getSalesColumnsArr() {
    let types = [
      //'outgoing_rest_bpm',
      'financial_price_b2c',
      'financial_price_b2b_incl_vat_btpm',
      'financial_price_gross_incl_btw_bpm',
    ];

    if (this.props.values?.tax_type == 'BTW' || (!this.isInstallation && this.props.values?.tax_type == 'marge')) {
      types = types.concat(...['financial_price_nett_excl_vat_bpm']);
    }

    if (this.props.values.tax_type === 'BTW' && this.props.values.vehicle_purpose === 'commercial' && this.isInstallation) {
      types = types.filter(type => type !== 'financial_price_gross_incl_btw_bpm');
    }

    return types;
  }

  get salesDataProps() {
    return [];
  }
  get salesPricesProps() {
    return [
      // 'financial_price_b2c',
      'financial_price_b2b_incl_vat_btpm',
      'financial_price_gross_incl_btw_bpm',
      'financial_price_nett_excl_vat_bpm',
      'outgoing_rest_bpm',
      'catalogprice_incl_options',
      // 'delivery_costs',
    ];
  }

  get firstColumnTypes() {
    let types = ['buying_company', 'buying_contact', 'sales_preferred_vehicle'];
    if (this.isInstallation) {
      types.pop();
    }
    if (this.isInstallation) {
      types = types.concat(...['vehicle_purpose', 'tax_type']);
    }

    return types;
  }

  wrapFieldIntoPermissionsComp(property, component) {
    if (!property) return '';
    let permission = null;
    if (this.purchasingDataProps.includes(property)) permission = PURCHASING_DATA_CRUD;
    if (this.purchasingPricesProps.includes(property)) permission = PURCHASING_PRICES_CRUD;
    if (this.salesDataProps.includes(property)) permission = SALES_DATA_CRUD;
    if (this.salesPricesProps.includes(property)) permission = SALES_PRICES_CRUD;

    if (this.isInstallation) return component;
    return <Permission permission={permission}>{component}</Permission>;
  }

  isCalculating() {
    return !!this.props.calcWorks || !!this.state.disableSave;
  }

  render() {
    if (this.props.work) return <Loader small />;

    const financialTypesArrCol = this.getPurchaseColumnsArr();
    const salesColumnsArr = this.getSalesColumnsArr();

    return (
      <Container className={styles.container}>
        <VBox className={cn('cols', styles.containerCol)}>
          <div className={cn('container-fluid info-card text-muted', styles.containerForm)}>
            <HBox flip={window.innerWidth < 769} className={styles.wrapper}>
              <div className={styles.containerFlex}>
                <h2 className={styles.title1}>{this.lbl('vehicle.create.columns.purchase')}</h2>
                {this.firstColumnTypes.map((type, index) => {
                  if (index == 1 && this.isInstallation) {
                    return this.wrapFieldIntoPermissionsComp(
                      type,
                      <>
                        <VehicleCreateField
                          key={type}
                          type={type}
                          vehicle_id={this.props.vehicle_id}
                          creditorInfo={this.props.creditorInfo}
                        />
                         <HBox style={{ marginBottom: '70px' }}></HBox>
                      </>,
                    );
                  }
                  return this.wrapFieldIntoPermissionsComp(
                    type,
                    <VehicleCreateField
                      key={type}
                      type={type}
                      vehicle_id={this.props.vehicle_id}
                      creditorInfo={this.props.creditorInfo}
                    />,
                  );
                })}
              </div>

              <div className={styles.containerFlex}>
                <h2 className={styles.title1}>{this.lbl('vehicle.create.columns.purchasing_prices')}</h2>
                {financialTypesArrCol.map((type, index) => {
                  if (index == 1 && this.isInstallation) {
                    return this.wrapFieldIntoPermissionsComp(
                      type,
                      <>
                        <VehicleCreateField
                          key={type}
                          type={type}
                          vehicle_id={this.props.vehicle_id}
                          saveDisable={this.toggleDisableSave}
                        />
                    <HBox style={{ marginBottom: '100px' }}></HBox>

                      </>,
                    );
                  }

                  return this.wrapFieldIntoPermissionsComp(
                    type,
                    <VehicleCreateField
                      key={type}
                      type={type}
                      vehicle_id={this.props.vehicle_id}
                      saveDisable={this.toggleDisableSave}
                    />,
                  );
                })}

                {/* <VBox className="col">
                <h2>{this.lbl('vehicle.create.columns.purchasing_prices')}</h2>
                {financialTypesArrCol.map((type, index) => {
                  if (index == 1 && this.isInstallation) {
                    return this.wrapFieldIntoPermissionsComp(
                      type,
                      <>
                        <VehicleCreateField
                          key={type}
                          type={type}
                          vehicle_id={this.props.vehicle_id}
                          saveDisable={this.toggleDisableSave}
                        />
                        <HBox style={{ marginBottom: '100px' }}></HBox>
                      </>,
                    );
                  }

                  return this.wrapFieldIntoPermissionsComp(
                    type,
                    <VehicleCreateField
                      key={type}
                      type={type}
                      vehicle_id={this.props.vehicle_id}
                      saveDisable={this.toggleDisableSave}
                    />,
                  );
                })}
              </VBox> */}
              </div>

              {/* <VBox className="col">
                <h2>{this.lbl('vehicle.create.columns.sales_prices')}</h2>

                {salesColumnsArr?.map((type, index) => {
                  if (index == 1 && this.isInstallation) {
                    return this.wrapFieldIntoPermissionsComp(
                      type,
                      <>
                        <VehicleCreateField
                          key={type}
                          type={type}
                          vehicle_id={this.props.vehicle_id}
                          saveDisable={this.toggleDisableSave}
                        />
                        <HBox style={{ marginBottom: '100px' }}></HBox>
                      </>,
                    );
                  }

                  return this.wrapFieldIntoPermissionsComp(
                    type,
                    <VehicleCreateField
                      key={type}
                      type={type}
                      vehicle_id={this.props.vehicle_id}
                      saveDisable={this.toggleDisableSave}
                    />,
                  );
                })}
                <div style={{ color: 'red' }}>
                  {this.props.values?.vehicle_purpose == 'commercial' &&
                    this.props.values?.tax_type == 'BTW' &&
                    this.isInstallation &&
                    'LET OP: verkoopprijzen excl btw vullen'}
                </div>
              </VBox> */}

              <div className={styles.containerFlex}>
                <h2 className={styles.title1}>{this.lbl('vehicle.create.columns.sales_prices')}</h2>

                {salesColumnsArr?.map((type, index) => {
                  if (index == 1 && this.isInstallation) {
                    return this.wrapFieldIntoPermissionsComp(
                      type,
                      <>
                        <VehicleCreateField
                          key={type}
                          type={type}
                          vehicle_id={this.props.vehicle_id}
                          saveDisable={this.toggleDisableSave}
                        />
                         <HBox style={{ marginBottom: '100px' }}></HBox>
                      </>
                    );
                  }

                  return this.wrapFieldIntoPermissionsComp(
                    type,
                    <>

                    <VehicleCreateField
                      key={type}
                      type={type}
                      vehicle_id={this.props.vehicle_id}
                      saveDisable={this.toggleDisableSave}
                    />
                    </>
                  );
                })}
                <div style={{ color: 'red' }}>
                  {this.props.values?.vehicle_purpose == 'commercial' &&
                    this.props.values?.tax_type == 'BTW' &&
                    this.isInstallation &&
                    'LET OP: verkoopprijzen excl btw vullen'}
                </div>
              </div>
            </HBox>

            <div className={cn('d-flex gap-2 justify-content-end mt-2', styles.buttonContainerBottom)}>
              <ButtonComponent style="ButtonSoftPrimary" onClick={this.prevStep.bind(this)} small>
                {this.lbl('previous')}
              </ButtonComponent>

              <ButtonComponent style="ButtonSoftEdit" onClick={this.save.bind(this)} small disabled={this.isCalculating()}>
                {this.isCalculating() ? this.lbl('calculating_progreess') : this.lbl('save')}
              </ButtonComponent>
            </div>
          </div>
        </VBox>
      </Container>
    );
  }
}

VehicleCreateStep2Comp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_VEHICLE]),
    values: selectNewVehicle(),
    calcWorks: selectWorks([CALCULATE_PURCHASE_PRICES_BTW, CALCULATE_PURCHASE_PRICES_MARGE]),
    serverConfig: selectConfig(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    create(properties, options, callback) {
      debugger;
      dispatch(createVehicleWithProps(properties, options, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleCreateStep2 = compose(withConnect, withRouter)(VehicleCreateStep2Comp);
